import { Dispatch } from 'redux';
import { IAppState } from '@mafc/common';

import { IMapString } from 'common/interfaces/common.interface';
import EApiMiddlewareMethod from 'config/redux/middlewares/api.middleware.enum';
import { APIGEE_LABELS_URL } from 'pages/Checkout/constants/apis.constant';
import EApigeeLabelTypes from './ApigeeLabel.type';

export const fetchApigeeLabels = () => (dispatch: Dispatch, getState: () => IAppState) => {
  const {
    appConfig: { language },
  } = getState();
  dispatch({
    type: EApigeeLabelTypes.FETCH_APIGEE_LABEL,
    payload: {
      enableProgress: true,
      method: EApiMiddlewareMethod.GET,
      url: APIGEE_LABELS_URL,
      apiVersion: 3,
      onSuccess: (response: { [k: string]: IMapString }) => {
        const labels: IMapString = {};
        const labelKeys = Object.keys(response);

        labelKeys.forEach(labelKey => {
          const languageLabel = response[labelKey][language];
          labels[labelKey] = languageLabel;
        });

        dispatch({
          type: EApigeeLabelTypes.FETCH_APIGEE_LABEL_SUCCESS,
          payload: labels,
        });
      },
      onFailure: () => {
        dispatch({
          type: EApigeeLabelTypes.FETCH_APIGEE_LABEL_ERROR,
        });
      },
    },
  });
};
